enum AuthRoutes {
    LOGIN = 'login',
    VERIFY = 'verification-code',
    FORGOT = 'forgot',
    NEW_PASSWORD = 'new-password',
    ACCEPT_INVITE = 'accept-invitation',
}

export default AuthRoutes
